export enum typeProspectEnum {
	contact = 'contact', // Personne physique
	account = 'account' // Personne morale
}

export enum roleProspectEnum {
	locataire = 221310003,
	colocataire = 221310007
}
